export const COMPANY_TAG_GROUPS = [
  {
    key: "roles",
    title: "Роль",
    names: ["Заказчик", "Подрядчик", "Поставщик"],
  },

  {
    key: "design",
    title: "Проектирование и девелопмент",
    names: ["Дизайн-студия", "Архитектурное бюро", "Девелопер", "Застройщик"],
  },

  {
    key: "production",
    title: "Производство и работы",
    names: [
      "Производство",
      "Мебельный цех",
      "Монтаж",
      "Доставка",
      "Логистика",
      "Замер",
      "Камень",
      "Стекло",
      "Металл",
    ],
  },

  {
    key: "supplies",
    title: "Поставки и торговля",
    names: ["Фурнитура", "Материалы", "Оборудование", "Мебельный магазин"],
  },
] as const;

export const normalizeTagName = (value?: string | null) =>
  (value ?? "").trim().toLocaleLowerCase("ru-RU");
